// export type ChatInputProps =

import { CustomComponentProps } from "utils/types/generalTypes";
import SVG from "../core/SVG";
import { useEffect, useRef, useState } from "react";
import customToaster from "../core/customToaster";
import { RootState } from "services/redux/store";
import { useSelector } from "react-redux";
import Input from "../inputs/Input";
import ChatEmojiModal from "./ChatEmojiModal";
import { EmojiClickData } from "emoji-picker-react";
import ChatGiFsModal from "./ChatGiFsModal";
import Button from "../core/Button";
export type ChatInputProps = CustomComponentProps & {
    addMsg: (msg: string, type: "text" | "media") => void;
    // previewImage: File | null;
    // setPreviewImage: React.Dispatch<React.SetStateAction<File | null>>;
};
const ChatInput = ({
    addMsg,
    // previewImage,
    // setPreviewImage,
    className,
    style
}: ChatInputProps) => {
    const mode = useSelector((state: RootState) => state.site.mode);
    const imgInputRef = useRef(null);
    const emojiBtnRef = useRef(null);

    // image preview
    const [previewImage, setPreviewImage] = useState<null | File>(null);
    const handleChangeImage = (images: FileList) => {
        // validate image
        if (!images[0]) {
            return;
        }
        if (images.length > 1) {
            customToaster("error", "You can select 1 image only", mode);
            return;
        }

        if (!images[0].name.match(/\.(jpg|jpeg|png)$/)) {
            customToaster("error", "Please select valid imag", mode);
            return;
        } else {
            setPreviewImage(images[0]);
            //addMsg(URL.createObjectURL(images[0]), "media");
            // clearAllInputs();
        }
    };

    // text
    const [msg, setMsg] = useState("");

    const [openEmojiModal, setOpenEmojiModal] = useState(false);
    const [emojiModalPosition, setEmojiModalPosition] = useState({
        left: 0,
        top: 0
    });
    const [selectedEmoji, setSelectedEmoji] = useState("");
    const openEmoji = () => {
        // dispatch(setEmojiPostId(postId));
        setOpenEmojiModal(true);

        // @ts-ignore
        const rect = emojiBtnRef.current.getBoundingClientRect();
        console.log("rect", rect);
        const left = rect.left;
        const parentElBottom = rect.bottom;
        const elHeight = 400;
        const top = parentElBottom - elHeight - 25;
        setEmojiModalPosition({
            left,
            top
        });
    };

    useEffect(() => {
        if (selectedEmoji) {
            setMsg(() => msg + selectedEmoji);
            setSelectedEmoji("");
        }
    }, [selectedEmoji]);

    const addEmoji = (emoji: EmojiClickData) => {
        setSelectedEmoji(emoji.emoji);
    };

    const [openGif, setOpenGif] = useState(false);
    const selectGif = (url: string) => {
        // console.log(url);
        addMsg(url, "media");
        clearAllInputs();
    };

    const handleAddMsg = () => {
        if (msg) {
            addMsg(msg, "text");
            clearAllInputs();
        }
    };

    const handleAddImgMsg = () => {
        if (previewImage) {
            addMsg(URL.createObjectURL(previewImage), "media");
            clearAllInputs();
        }
    };

    const clearAllInputs = () => {
        setMsg("");
        setSelectedEmoji("");
        setOpenEmojiModal(false);
        setOpenGif(false);
        setPreviewImage(null);
        (imgInputRef.current as unknown as HTMLInputElement).value = "";
    };

    return (
        <>
            <div
                className={`d-flex gap-5 flex-j-between flex-a-center pr-15 pl-15 pt-5 pb-20 ${className}`}
                style={style}
            >
                {/* file input */}
                <div>
                    <input
                        className="is-hidden"
                        type="file"
                        name="post-1-img"
                        id="post-1-img-i"
                        multiple
                        onChange={(e) =>
                            handleChangeImage(e.target.files as FileList)
                        }
                        accept="image/png, image/jpeg"
                        ref={imgInputRef}
                    />
                    <label
                        className="cursor-pointer"
                        onClick={() =>
                            (
                                imgInputRef.current as unknown as HTMLInputElement
                            ).click()
                        }
                    >
                        <SVG svg="paperclip" size={20} />
                    </label>
                </div>
                {/* add gifs btn */}
                <div className="post-form-input-container">
                    <div
                        className="blue-white-text cursor-pointer"
                        onClick={() => setOpenGif(true)}
                    >
                        <SVG svg="gif2" size={20} />
                    </div>
                </div>
                {/* emoji btn */}
                <div className="post-form-input-container p-relative">
                    <div
                        className="blue-white-text cursor-pointer"
                        onClick={openEmoji}
                        ref={emojiBtnRef}
                    >
                        <SVG svg="emoji" size={20} />
                    </div>
                </div>
                {/* text input */}
                <Input
                    value={msg}
                    handleChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        setMsg(e.target.value)
                    }
                    rounded
                    className="w-full"
                    style={{ marginBottom: 0 }}
                />
                {/* send btn */}
                <div className="svg-circle bigg-circle" onClick={handleAddMsg}>
                    <SVG svg="chat-send" size={20} className="blue-svg" />
                </div>
            </div>

            {previewImage && (
                <div className="profile-followers-card card d-flex flex-col gap-5 preview-img-div">
                    <div className="w-full pt-10 pb-10 pr-20 d-flex flex-j-end">
                        <div onClick={() => setPreviewImage(null)}>
                            <SVG svg="close" size={20} />
                        </div>
                    </div>
                    <div className="d-flex flex-j-center flex-a-center pr-10 pl-10 pt-10 pb-10 h-full">
                        <img
                            className="preview-image"
                            src={URL.createObjectURL(previewImage)}
                            alt="preview image"
                        />
                    </div>
                    <div className="w-full pt-10 pb-20 pr-20 d-flex flex-j-end">
                        <div
                            className="svg-circle bigg-circle"
                            onClick={handleAddImgMsg}
                        >
                            <SVG
                                svg="chat-send"
                                size={20}
                                className="blue-svg"
                            />
                        </div>
                    </div>
                </div>
            )}
            <ChatEmojiModal
                open={openEmojiModal}
                setOpen={setOpenEmojiModal}
                left={emojiModalPosition.left}
                top={emojiModalPosition.top}
                addEmoji={addEmoji}
            />
            <ChatGiFsModal
                open={openGif}
                setOpen={setOpenGif}
                selectGif={selectGif}
            />
        </>
    );
};

export default ChatInput;
